import { Box, Grid, InputAdornment, TextField, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormValues } from "../../routes/Profile/AddSkillBook/AddSkillBook.types";


interface InformationTrainingSectionProps {
  formValues: FormValues;
  setFormValues: React.Dispatch<React.SetStateAction<FormValues>>;
  readOnly?: boolean;
}

const InformationTrainingSection: React.FC<InformationTrainingSectionProps> = ( {
  formValues,
  setFormValues,
  readOnly
} ) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues((prev: FormValues) => ({ ...prev, [name]: value }));
  };


  const { t } = useTranslation();
  const theme = useTheme();

  const formatCost = () => {
    const value = formValues.cost as string | number;

    if (value !== undefined && value !== null && !isNaN(Number(value))) {
      const formatted = parseFloat(value.toString()).toFixed(2).replace(".", ",");
      setFormValues(prev => ({
        ...prev,
        cost: formatted
      }));
    }
  };

  return (
    <Box sx={ {
      border: `${theme.customColors.borderAccent} 1px solid`,
      borderRadius: 2,
      p: 2,
      mb: 3,
      boxShadow: `${theme.customColors.borderAccent} 0 0 10px`
    } }>
      <Typography variant="h6" color={ theme.customColors.textWidget } sx={ { marginRight: "auto" } }>
        { t("informaton_course") }
      </Typography>

      { /* Campi modificabili */ }
      <Box sx={ { display: "flex", flexDirection: "column", gap: 2 } }>
        <Grid container>
          <Grid item md={ 12 }><p style={ {  fontSize: "10px"  } }>{ t("dispenser_field") }</p></Grid>
          <Grid item md={ 12 }>
            <TextField
              fullWidth
              name="provider"
              label="-"
              size="small"
              variant="outlined"
              value={ formValues.provider as string || "" }
              onChange={ handleInputChange }
              disabled={ readOnly }
              sx={ {
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: theme.customColors.textDisabledAlternative, // colore del testo disabilitato
                  opacity: 1                     // disattiva il grigio pallido
                },
                borderRadius: "8px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  "& fieldset": {
                    border: `1px solid ${theme.customColors.border}`
                  }
                }
              } }
            />
            { /* <input
              name="provider"
              placeholder="-"
              value={ formValues.provider as string || "" }
              onChange={ handleInputChange }
              style={ { padding: 8, borderRadius: 8, border: `1px solid ${theme.customColors.border}`, backgroundColor: theme.customColors.backgroundSecondary, color: theme.customColors.textWidget, width: "100%", outline: "none" } }
              onFocus={ (e) => e.target.style.backgroundColor = theme.customColors.backgroundSecondary }
              onBlur={ (e) => e.target.style.backgroundColor = theme.customColors.backgroundSecondary }
            /> */ }
          </Grid>
        </Grid>
        <Grid>
          <p style={ {  fontSize: "10px"  } }>{ t("title_trining_field") }</p>
          <TextField
            fullWidth
            name="title"
            label="-"
            size="small"
            variant="outlined"
            value={ formValues.title as string || "" }
            onChange={ handleInputChange }
            disabled={ readOnly }
            sx={ {
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: theme.customColors.textDisabledAlternative, // colore del testo disabilitato
                opacity: 1                     // disattiva il grigio pallido
              },
              borderRadius: "8px",
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                "& fieldset": {
                  border: `1px solid ${theme.customColors.border}`
                }
              }
            } }
          />
          { /* <input
            name="title"
            placeholder="-"
            value={ formValues.title as string || "" }
            onChange={ handleInputChange }
            style={ { padding: 8, borderRadius: 8, border: `1px solid ${theme.customColors.border}`, backgroundColor: theme.customColors.backgroundSecondary, color: theme.customColors.textWidget, width: "100%", outline: "none" } }
          /> */ }
        </Grid>
        <Grid container spacing={ 2 }>

          <Grid item xs={ 6 }>
            <p style={ {  fontSize: "10px"  } }>{ t("duration_field") }</p>
            <TextField
              fullWidth
              name="duration"
              placeholder="0"
              size="small"
              variant="outlined"
              value={ (formValues.duration as number | string | undefined) ?? 0 }
              onChange={ handleInputChange }
              disabled={ readOnly }
              sx={ {
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: theme.customColors.textDisabledAlternative, // colore del testo disabilitato
                  opacity: 1                     // disattiva il grigio pallido
                },
                borderRadius: "8px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  "& fieldset": {
                    border: `1px solid ${theme.customColors.border}`
                  }
                }
              } }
            />
          </Grid>
          <Grid item xs={ 6 }>
            <p style={ {  fontSize: "10px"  } }>{ t("cost_field") }</p>
            <TextField
              fullWidth
              name="cost"
              label="-"
              size="small"
              variant="outlined"
              value={ formValues.cost as number || "" }
              onChange={ handleInputChange }
              onBlur={ formatCost }
              sx={ {
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: theme.customColors.textDisabledAlternative, // colore del testo disabilitato
                  opacity: 1                     // disattiva il grigio pallido
                },
                borderRadius: "8px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  "& fieldset": {
                    border: `1px solid ${theme.customColors.border}`
                  }
                }
              } }
              placeholder="0,00"
              InputProps={ {
                startAdornment:
                  !formValues.cost ? (
                    <InputAdornment position="start">
                      <span style={ { color: theme.customColors.textWidget } }>€</span>
                    </InputAdornment>
                  ) : (
                    <InputAdornment position="start">
                      <span style={ { color: theme.customColors.textWidget } }>€</span>
                    </InputAdornment>
                  )
              } }
              disabled={ readOnly }
            />
          </Grid>
        </Grid>
      </Box>

    </Box>
  );
};

export default InformationTrainingSection;
